import { observable, action } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';
import constants from '../constants';


export class StatisticsStore {
    @observable inProgress = false;
    @observable statusText;
    @observable errors;
    @observable addUserDialog = false;
    @observable changePasswordDialog = false;
    @observable pageNo = 0;
    @observable userMenuArray = [];
    @observable totalCount = 0;
    @observable superAdminStats = {};
    @observable countData = {
        'AI_PENDING': 0,
        'REVIEW_PENDING': 0,
        'REVIEW_COMPLETE': 0,
        'EXPORTED': 0
    }
    @observable adminStats = []
    @observable agentStats = [];
    @observable userStats = { 'assigned': 0, 'reviewed': 0, 'exported': 0 }

    @action getStatusReport(startDate, endDate) {
        this.inProgress = true;
        this.errors = undefined;
        return agent.Stats.getStatusReport(startDate, endDate)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.totalCount = response.data.totalUploaded;
                    this.countData = response.data.countData;
                    this.adminStats = response.data.adminPage.adminTasks;
                    this.agentStats = response.data.adminPage.agentTasks;
                    this.userStats = response.data.agentPage.agentTasks.length ? response.data.agentPage.agentTasks[0] : { 'assigned': 0, 'reviewed': 0, 'exported': 0 };
                    this.superAdminStats = response.data.superAdminPageStats; 
                }

            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action downloadReport() {
        this.statusText = '';
        this.errors = undefined;
        this.downloadProgress = true;
        return agent.Stats.getDownloadTokenForStats()
            .then(action((response) => {
                if (response.statusCode == '200') {
                    let link = document.createElement('a');
                    link.href = constants.API_ROOT + `/stats/downloadStatsReport?downloadToken=${response.data.downloadToken}&fileName=${response.data.fileName}`
                    link.click();
                }
                else
                    commonStore.handleOpenSnackBar(response.message, 'error')
            }))
            .catch(action((err) => {
                //this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.downloadProgress = false
            }))
    }

}


export default new StatisticsStore();
